import React, { useState } from "react";
import { injectIntl } from "react-intl";
import { Link } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroller";
import {
  ActionBar,
  ActionBarButtons,
  ButtonGroup,
  Clue,
  CreateActionButton,
  Container,
  List,
  Loader,
  isNothing,
  url,
  withApi,
  withBrowser,
  withNotifier,
  withUser,
  apiShape,
  browserShape,
  intlShape,
  notifierShape,
  userShape,
} from "lcm-iot-commons";
import TaxItem from "./TaxItem";

type TaxesProps = {
  api: apiShape;
  browser: browserShape;
  intl: intlShape;
  notifier: notifierShape;
  user: userShape;
};

export function Taxes({ api, browser, intl, notifier, user }: TaxesProps) {
  const [state, setState] = useState({
    fetching: false,
    taxes: undefined,
    itemDeleted: false,
    nextPageUrl: undefined,
  });

  const loadTaxes = async () => {
    try {
      setState({
        fetching: true,
        // @ts-expect-error TS(2322) FIXME: Type 'never[]' is not assignable to type 'undefine... Remove this comment to see the full error message
        taxes: [],
      });
      const response = await api.getAll("/taxes");
      // @ts-expect-error TS(2345) FIXME: Argument of type '{ fetching: false; taxes: any; }... Remove this comment to see the full error message
      setState({
        fetching: false,
        taxes: response.taxes,
      });
    } catch (error) {
      // @ts-expect-error TS(2345) FIXME: Argument of type '{ fetching: false; }' is not ass... Remove this comment to see the full error message
      setState({ fetching: false });
      notifier.showError(api.translateError(error));
    }
  };

  React.useEffect(() => {
    loadTaxes();
  }, []);

  const controllingDirector = (user as $TSFixMe)?.userRoles?.find(
    (ur: $TSFixMe) => ur.name === "controlling_director",
  );
  if (user && isNothing(controllingDirector)) {
    browser.navigateTo("/403");
  }

  const taxesCount =
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    (state.taxes as $TSFixMe)?.length > 0 ? state.taxes.length : null;

  const badge = state.fetching ? (
    <span className="loading">
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </span>
  ) : (
    taxesCount
  );

  const taxesList =
    (state.taxes as $TSFixMe)?.length > 0 ? (
      <List id="taxes-list">
        <InfiniteScroll initialLoad loadMore={loadTaxes} hasMore={false}>
          {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
          {state.taxes.map((tax: $TSFixMe) => (
            <TaxItem key={tax.id} tax={tax} loadTaxes={loadTaxes} />
          ))}
        </InfiniteScroll>
      </List>
    ) : (
      // @ts-expect-error TS(2322) FIXME: Type '{ children: Element; id: string; title: stri... Remove this comment to see the full error message
      <Clue
        id="no-taxes-found"
        title={intl.formatMessage({ id: "taxes.no_taxes_found" })}
        details={intl.formatMessage({ id: "taxes.no_taxes_found.ask_create" })}
        className="notification"
        highlighted
      >
        <ButtonGroup>
          <Link className="btn btn-primary" to={url("/taxes/create")}>
            {intl.formatMessage({ id: "taxes.create_tax" })}
          </Link>
        </ButtonGroup>
      </Clue>
    );

  return user ? (
    <Loader loading={state.fetching}>
      <Container>
        <ActionBar>
          <h1 id="taxes-header">
            {intl.formatMessage({ id: "taxes.header" })}
            <span id="taxes-count" className="badge">
              {badge}
            </span>
          </h1>
          <ActionBarButtons>
            <CreateActionButton
              // @ts-expect-error TS(2322) FIXME: Type '{ id: string; disabled: boolean; target: str... Remove this comment to see the full error message
              id="create-tax-button"
              disabled={isNothing(controllingDirector)}
              target="/taxes/create"
            />
          </ActionBarButtons>
        </ActionBar>
        {!state.fetching ? taxesList : null}
      </Container>
    </Loader>
  ) : null;
}

export default injectIntl(withUser(withApi(withBrowser(withNotifier(Taxes)))));
